import { v4 } from "uuid";

export const generateBrandgenCampaignUuid = () => `bg-campaign-${v4()}`;

export const generateBrandgenAdvertiserUuid = () => `bgAdvertiser-${v4()}`;
